var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m53.354 15.702c2.191-1.428 3.646-3.897 3.646-6.702 0-4.411-3.589-8-8-8-3.676 0-6.773 2.496-7.706 5.88l-5.88-5.88h-12.414v2h11.586l6.436 6.436c.143 2.623 1.547 4.912 3.624 6.266-5.593 1.836-9.646 7.099-9.646 13.298v7c0 2.757 2.243 5 5 5h1v17.5c0 2.481 2.019 4.5 4.5 4.5 1.421 0 2.675-.675 3.5-1.706.825 1.031 2.079 1.706 3.5 1.706 2.481 0 4.5-2.019 4.5-4.5v-17.5h1c2.757 0 5-2.243 5-5v-7c0-6.199-4.053-11.462-9.646-13.298zm-10.354-6.702c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6zm18 27c0 1.654-1.346 3-3 3h-1v-15h-2v34.5c0 1.378-1.121 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-24.5h-2v24.5c0 1.378-1.121 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-34.5h-2v15h-1c-1.654 0-3-1.346-3-3v-7c0-6.617 5.383-12 12-12s12 5.383 12 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 50.586v-9.586c2.206 0 4-1.794 4-4v-10c0-4.125-2.512-7.674-6.085-9.2 1.86-1.26 3.085-3.389 3.085-5.8 0-3.86-3.141-7-7-7s-7 3.14-7 7c0 2.411 1.225 4.54 3.085 5.8-3.573 1.526-6.085 5.075-6.085 9.2v10c0 2.206 1.794 4 4 4v18.5c0 1.93 1.57 3.5 3.5 3.5.98 0 1.864-.407 2.5-1.058.636.651 1.52 1.058 2.5 1.058 1.93 0 3.5-1.57 3.5-3.5v-6.086l6.414-6.414h11.586v-2h-12.414zm-11-38.586c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm9 47.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-25.5h-2v25.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-33.5h-2v13c-1.103 0-2-.897-2-2v-10c0-4.411 3.589-8 8-8s8 3.589 8 8v10c0 1.103-.897 2-2 2v-13h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33 49h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23 49h8v2h-8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23 5h8v2h-8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m33 5h2v2h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmi);
export default __webpack_public_path__ + "static/media/bmi.d29a1bdc2ab79c1761d2907109378e25.svg";
export { ForwardRef as ReactComponent };